module.exports = __webpack_public_path__ + "LatoLatin-SemiboldItalic.f4aaa0404ce1f63b4b16.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-SemiboldItalic.ttf
// module chunks = styles